import React, { useState } from 'react';
import api from '../../services/api';

const LazyImage = ({
  src,
  alt = '',
  width = 600,
  height = null,
  fit = 'cover',
  objectFit = 'cover',
  className = '',
  eager = false,
  fallback = null,
}) => {
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);
  const hasSrc = Boolean(src);
  const objectFitClass = objectFit === 'contain' ? 'object-contain' : 'object-cover';

  if (!hasSrc && !fallback) {
    return <div className={`absolute inset-0 bg-gray-200 animate-pulse ${className}`} />;
  }

  const imageSrc = api.utils.getImageUrl(src || fallback, { width, height, fit });
  const placeholderSrc = hasSrc ? api.utils.getImagePlaceholder(src, 32) : null;

  return (
    <div className={`absolute inset-0 w-full h-full ${className}`}>
      {placeholderSrc && !loaded && !failed && (
        <img
          src={placeholderSrc}
          alt=""
          aria-hidden="true"
          className={`absolute inset-0 w-full h-full ${objectFitClass} scale-110 blur-sm`}
        />
      )}
      {!loaded && !failed && <div className="absolute inset-0 bg-gray-200 animate-pulse" />}
      <img
        src={imageSrc}
        alt={alt}
        loading={eager ? 'eager' : 'lazy'}
        decoding="async"
        fetchPriority={eager ? 'high' : 'auto'}
        onLoad={() => setLoaded(true)}
        className={`absolute inset-0 w-full h-full min-w-full min-h-full ${objectFitClass} object-center transition-opacity duration-200 ${
          loaded ? 'opacity-100' : 'opacity-0'
        }`}
        onError={() => {
          if (fallback && !failed) {
            setFailed(true);
            setLoaded(false);
          }
        }}
      />
      {failed && fallback && (
        <img
          src={fallback}
          alt={alt}
          className={`absolute inset-0 w-full h-full ${objectFitClass} object-center`}
          onLoad={() => setLoaded(true)}
        />
      )}
    </div>
  );
};

export default LazyImage;
